export default {
  title: 'We’re Closed',
  subtitle: 'Taking a short break!',
  description: 'While our doors are closed, you can easily schedule your next order right now.',
  buttons: {
    schedule_order: 'Schedule Order',
    close: 'Close',
  },
  errors: {
    scheduled_for: 'Specify date & time',
  },
};
